import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useCanViewPersonContactBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonContactAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonContact = useCanViewPersonContactBool();

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonContact });

  return {
    loaded,
    canViewPersonContact
  };
}
